import React, { useEffect } from 'react';
import styles from '../../styles/cards.module.css'
import { recursosFederales } from '../../json/recursosFederales';

const RecursosFederales = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='transparencia_title'>
                        <h3 className={ styles.title }>
                            Informes Trimestrales de los Recursos Federales recibidos por esta Secretaría
                        </h3>
                        <hr className='hr-gob'></hr>
                    </div>
                </div>
                {
                    recursosFederales.map((item, index) => (
                        <div key={ index } className='col-md-3 col-sm-6 col-12'>
                            <div className={ styles.container }>
                                <h5 className={ styles.name }>
                                    { item.anio }
                                </h5>
                                <hr></hr>
                                {
                                    item.trimestres.map((item, index) => (
                                        <div key={ index }>
                                            <a className={ styles.link } href={ item.documento } target='_blank' rel='noopener noreferrer'>
                                                <div className={ styles.item }>
                                                    <p className={ styles.textLink }>
                                                        { item.trimestre }
                                                    </p>
                                                    <i className={`icon-file-pdf ${ styles.iconLink }`} aria-hidden='true'></i>
                                                </div>
                                            </a>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default RecursosFederales